import { Popover, Table } from 'antd';
import styles from './index.module.scss';
import { getEnumLabel } from 'libs/utils';
import { NetPriceSourceEnum } from 'libs/enums';
import {
  templatePriceConfigQuoteMode,
  findEnum,
  accountPeriodTypes,
  settlementConfigBillingPeriodList,
  priceFloatList,
  aluminumPriceFloatList,
  mixingStationRenderInstruct,
  discountTypeEnum,
  doubleAttributeConfigListRenderInstruct,
  pricingModelEnum,
  priceRuleList,
} from './helper';
import { cls } from 'reactutils';
import { groupBy, values } from 'lodash';
import { useMemo } from 'react';
// 浮动比例设置列表columns
const tradeModePriceRenderInstructConcrete = (previewObj, priceTxt) => {
  return [
    {
      dataIndex: 'accountPeriod',
      title: '交易方式',
      align: 'center',
      width: '200px',
      render: function (text, record) {
        const item = findEnum(accountPeriodTypes, record.accountPeriodEnum);
        if (item.value !== 0) {
          return item.label;
        } else {
          if (
            record.billingPeriodEnum === 6 &&
            previewObj.config.settlementConfig?.billingPeriodOtherDays
          ) {
            return previewObj.config.settlementConfig.billingPeriodOtherDays + '天后一次性付款';
          } else {
            const billingPeriod = getEnumLabel({
              enums: settlementConfigBillingPeriodList,
              value: record.billingPeriodEnum,
            });
            return billingPeriod + '';
          }
        }
      },
    },
    {
      dataIndex: 'discount',
      title: '调整比例 （%）',
      align: 'center',
      width: '200px',
    },
    {
      dataIndex: 'organizationName',
      title() {
        return (
          <div>
            价格公式
            <Popover
              color="#515151"
              content={
                <div className={styles.mode_tooltip_content}>
                  <div>价格 = {priceTxt} * (1 + 调整比例%) </div>
                  <div>最终价格将对计算结果进行四舍五入处理</div>
                </div>
              }
              trigger="hover"
            >
              <i className={cls('iconfont icon-question1', styles.pay_question_icon)} />
            </Popover>
          </div>
        );
      },
      align: 'center',
      render: function (_, data) {
        if (data.discount === 0) return priceTxt;
        const discount =
          data.discount > 0
            ? '1 + ' + +data.discount + '%'
            : '1 - ' + Math.abs(+data.discount) + '%';
        return `${priceTxt} * ` + '(' + discount + ')';
      },
    },
  ];
};
const anchorRulesRenderInstructFn = (row) => {
  var baseColumns = [
    {
      dataIndex: 'breedCode',
      title: '锚定品种',
      width: '100px',
      render: function (_, data) {
        return data.breedAnchor.breedName;
      },
    },
    {
      dataIndex: 'materialCategorySysNo',
      title: '材料库类别',
      width: '100px',
      render: function (_, data) {
        return data.breedAnchor.materialCategoryName;
      },
    },
  ];

  var materialQuantityColumns = [
    {
      dataIndex: 'materialQuantityCode',
      title: '锚定材质',
      width: '100px',
      className: 'border-left',
      render: function (_, data) {
        return data.materialQuantityAnchor.materialQuantityName;
      },
    },
    {
      dataIndex: 'materialQuantityAnchor_attributeList',
      title: '材料库属性',
      width: '150px',
      render: function (_, data) {
        return data.materialQuantityAnchor.attributeList
          .map(function (item) {
            return item.attributeName;
          })
          .join('，');
      },
    },
  ];

  row.materialQuantityAnchor.attributeList.forEach(function (attribute) {
    var dynamicColumn = {
      dataIndex: attribute.attributeValueSysNo,
      title: attribute.attributeName,
      width: '100px',
      render: function () {
        return attribute.attributeValueName;
      },
    };
    materialQuantityColumns.push(dynamicColumn);
  });

  var modelAnchorColumns = [
    {
      dataIndex: 'modelCode',
      title: '锚定规格',
      width: '100px',
      className: 'border-left',
      render: function (_, data) {
        return data.modelAnchor.modelName;
      },
    },
    {
      dataIndex: 'modelAnchor_attributeList',
      title: '材料库属性',
      width: '150px',
      render: function (_, data) {
        return data.modelAnchor.attributeList
          .map(function (item) {
            return item.attributeName;
          })
          .join('，');
      },
    },
  ];

  row.modelAnchor.attributeList.forEach(function (attribute) {
    var dynamicColumn = {
      dataIndex: attribute.attributeValueSysNo,
      title: attribute.attributeName,
      width: '100px',
      render: function () {
        return attribute.attributeValueName;
      },
    };
    modelAnchorColumns.push(dynamicColumn);
  });

  return baseColumns.concat(materialQuantityColumns, modelAnchorColumns);
};
// 报价类型
const QuoteType = ({ config }) => {
  return (
    <div className={styles.row_item}>
      <div className={styles.label}>报价类型:</div>
      <div className={styles.value}>
        <div className={styles.value_item}>
          {getEnumLabel({
            enums: templatePriceConfigQuoteMode,
            value: config?.quoteModeEnum,
          })}
          <Popover
            color="#515151"
            content={
              <div className={styles.mode_tooltip_content}>
                {config?.quoteModeEnum === templatePriceConfigQuoteMode.IncluedTax.value ? (
                  <>
                    <h4>含税单计价</h4>
                    <span>
                      综合单价 = 含税单价
                      <br />
                      小计 = 综合单价 * 数量
                    </span>
                  </>
                ) : (
                  <>
                    <h4 className="mt10">除税价计价</h4>
                    <span>
                      综合单价 = 除税单价 *（1 + 税率）
                      <br />
                      小计 = 除税单价 *（1 + 税率） * 数量
                    </span>
                  </>
                )}
              </div>
            }
            trigger="hover"
          >
            <i className={cls('iconfont icon-question1', styles.pay_question_icon)} />
          </Popover>
          ，商品开票税率为 {config?.taxRate}%
        </div>
      </div>
    </div>
  );
};
// 依据店铺销售价格浮动定价
export const BaseOnSellPrice = ({ previewObj }) => {
  return (
    <>
      <QuoteType config={previewObj.config?.baseOnSellPrice} />

      <div className={cls(styles.row_item, styles.row_item_with_table)}>
        <div className={styles.label}>浮动比例设置:</div>
        <Table
          pagination={false}
          columns={tradeModePriceRenderInstructConcrete(previewObj, '商品销售价')}
          dataSource={previewObj.config?.baseOnSellPrice?.discountByMethodList}
          bordered
        />
      </div>
    </>
  );
};

// 固定协议价
export const BasePrice = ({ previewObj }) => {
  return (
    <>
      <QuoteType config={previewObj.config?.basePriceConfig} />
      <div className={cls(styles.row_item, styles.row_item_with_table)}>
        <div className={styles.label}>浮动比例设置:</div>
        <Table
          pagination={false}
          columns={tradeModePriceRenderInstructConcrete(previewObj, '商品销售价')}
          dataSource={previewObj.config?.basePriceConfig?.discountByMethodList}
          bordered
        />
      </div>
    </>
  );
};

export const SteelBarNetPrice = ({ previewObj, regionList, netPriceType }) => {
  const anchoredBrandConfigListRenderInstruct = [
    {
      dataIndex: 'name',
      align: 'center',
      title: (previewObj.config?.rebarPriceConfig?.netPriceSource || '') + '品牌',
      render: function (_, data) {
        return data.netBrand.name;
      },
    },
  ];
  const ruleListRenderInstruct = [
    {
      dataIndex: 'name',
      align: 'center',
      title: (previewObj.config?.rebarPriceConfig?.netPriceSource || '') + '品牌',
      render: function (_, data) {
        return data.thirdBrandName;
      },
    },
  ];
  const priceParamListRenderInstruct = [
    {
      dataIndex: 'name',
      title: (previewObj.config.rebarPriceConfig.netPriceSource || '') + '指定规格',
      width: '300px',
      align: 'center',
      render: function (_, data) {
        return data.breedName + '/' + data.materialQuantity + '/' + data.model;
      },
    },
    {
      dataIndex: 'sort',
      title: '优先级',
      align: 'center',
      render: function (_, _data, index) {
        return index + 1;
      },
    },
  ];
  const anchoredCityListRenderInstruct = [
    {
      dataIndex: 'cityName',
      title: '城市',
      width: '200px',
      align: 'center',
    },
    {
      dataIndex: 'anchoredCityName',
      title: '锚定城市(参考该城市网价)',
      align: 'center',
    },
  ];
  const categoryDiscountListRenderInstruct = [
    {
      dataIndex: 'categoryName',
      title: '类别',
      width: '200px',
      align: 'center',
    },
    {
      dataIndex: 'formula',
      title: '单价计价公式类型',
      width: '200px',
      align: 'center',
    },
    {
      dataIndex: 'formulaString',
      title: '单价计价公式',
      width: '272px',
      align: 'center',
    },
  ];
  const getPriceRuleList = [
    {
      title: () => '(1) 以哪个环节的日期为准取定基价',
      render() {
        return [...accountPeriodTypes]
          .filter((v) => previewObj.config.accountPeriodEnumList.includes(v.value))
          .sort((a, b) => a.seq - b.seq)
          .map((v, i) => (
            <div className={styles.value_block_list_item} key={i}>
              • {v.label}方式，取
              {previewObj.config?.rebarPriceConfig?.takePriceRule && (
                <span className={styles.value_block_list_item_light_txt}>
                  {previewObj.config.rebarPriceConfig.takePriceRule[v.netPriceAttr]}
                </span>
              )}
              网价
            </div>
          ));
      },
    },
    {
      title() {
        return (
          <div>
            (2) 取当天哪一条网价
            <Popover
              content={
                <div className={styles.mode_tooltip_content}>
                  <p>均以当天提交单据时已发布的网价进行计算</p>
                </div>
              }
              color="#515151"
              trigger="hover"
            >
              <i className={cls('iconfont icon-question1', styles.pay_question_icon)} />
            </Popover>
          </div>
        );
      },
      render: () => `• ${previewObj.config?.rebarPriceConfig?.takePriceRule?.priceSelect}`,
    },
    {
      title: () => '(3) 当天取价时暂未发布网价规则',
      render: () => '• 取前1个工作日的网价',
    },
    {
      title: () => '(4) 节假日，周末取价规则',
      render: () =>
        '• 周末取周五的网价，节假日取放假前一天同城市，同品牌，同规格型号网价，如遇到周末，顺延至周五',
    },
    {
      title: () => '(5) 规格型号锚定规则',
      render() {
        return (
          <div className={cls(styles.value_block_list_item, styles.mt10)}>
            {previewObj.config?.rebarPriceConfig?.takePriceRule?.anchoredBreedMaterialQuantityModelConfigList?.map(
              (item, i) => (
                <div className={styles.anchor_table_item} key={i}>
                  <Table
                    pagination={false}
                    columns={anchorRulesRenderInstructFn(item)}
                    dataSource={[item]}
                    bordered
                  />
                </div>
              ),
            )}
          </div>
        );
      },
    },
    {
      title: () => '(6) 品牌锚定规则',
      render() {
        return (
          <div className={cls(styles.value_block_list_item, styles.mt10)}>
            <div className={styles.anchor_table_item}>
              <Table
                pagination={false}
                columns={anchoredBrandConfigListRenderInstruct}
                dataSource={
                  previewObj.config?.rebarPriceConfig?.takePriceRule?.anchoredBrandConfigList || []
                }
                bordered
              />
            </div>
          </div>
        );
      },
    },
    {
      title: () => '(7) 品牌无网价规则',
      render: () => {
        return (
          <div className={styles.value_block_list_item}>
            {'• '}
            {previewObj.config?.rebarPriceConfig?.takePriceRule?.netPriceStandByRule}
            {previewObj.config?.rebarPriceConfig?.takePriceRule?.netPriceStandByRuleEnum === 4 &&
              previewObj.config.rebarPriceConfig.takePriceRule.multiBrandAverageConfig && (
                <Table
                  pagination={false}
                  columns={[
                    {
                      dataIndex: 'name',
                      title: previewObj.config.rebarPriceConfig.netPriceSource || '',
                      render: function (_, data) {
                        return data;
                      },
                    },
                  ]}
                  dataSource={
                    previewObj.config.rebarPriceConfig.takePriceRule.multiBrandAverageConfig
                      .thirdBrandNameList || []
                  }
                  bordered
                />
              )}

            {previewObj.config?.rebarPriceConfig?.takePriceRule?.netPriceStandByRuleEnum === 5 &&
              previewObj.config.rebarPriceConfig.takePriceRule.brandToThirdBrandConfig && (
                <Table
                  pagination={false}
                  columns={ruleListRenderInstruct}
                  dataSource={
                    previewObj.config.rebarPriceConfig.takePriceRule.brandToThirdBrandConfig
                      .ruleList || []
                  }
                  bordered
                />
              )}

            {previewObj.config?.rebarPriceConfig?.takePriceRule?.netPriceStandByRuleEnum === 6 &&
              previewObj.config.rebarPriceConfig.takePriceRule.thirdBrandDifferenceConfig && (
                <Table
                  pagination={false}
                  columns={priceParamListRenderInstruct}
                  dataSource={
                    previewObj.config.rebarPriceConfig.takePriceRule.thirdBrandDifferenceConfig
                      .priceParamList || []
                  }
                  bordered
                />
              )}
          </div>
        );
      },
    },
    {
      title: () => '(8) 城市取价规则，默认取本城市网价，如设定锚定城市，则取锚定城市网价',
      render() {
        return previewObj.config?.rebarPriceConfig?.takePriceRule?.anchoredCityConfig ? (
          <div className={styles.value_block_list_item}>
            <div className={styles.anchor_table_item}>
              <Table
                pagination={false}
                columns={anchoredCityListRenderInstruct}
                dataSource={
                  previewObj.config.rebarPriceConfig.takePriceRule.anchoredCityConfig.configList ||
                  []
                }
                bordered
              />
            </div>
          </div>
        ) : (
          ''
        );
      },
    },
    {
      title: () => '(9) 不满足上述情况，采购方手动输入单价',
      render: () => '',
    },
  ];
  return (
    <>
      <QuoteType config={previewObj.config?.rebarPriceConfig} />
      {netPriceType && (
        <div className={styles.row_item}>
          <div className={styles.label}>网价来源:</div>
          <div className={styles.value}>
            <div className={styles.value_item}>{netPriceType === 2 ? '兰格网' : '我的钢铁网'}</div>
          </div>
        </div>
      )}
      <div className={styles.row_item}>
        <div className={styles.label}>价格类型:</div>
        <div className={styles.value}>
          <div className={styles.value_item}>
            {previewObj.config?.rebarPriceConfig?.priceSourceEnum === 2 ? '工程采购价' : '市场价'}
          </div>
        </div>
      </div>
      <div className={styles.row_item}>
        <div className={styles.label}>取价规则:</div>
        <div className={styles.value}>
          {getPriceRuleList.map((v, i) => (
            <div className={styles.value_block_wrap} key={i}>
              <div className={styles.value_block_title}>{v.title()}</div>
              <div>{v.render()}</div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.row_item}>
        <div className={styles.label}>浮动规则:</div>
        <div className={styles.value}>
          <div className={styles.value_item}>
            {previewObj.config?.rebarPriceConfig?.areaDiscountRule}
            {previewObj.config?.rebarPriceConfig?.areaDiscountRuleEnum === 2 && (
              <span className={styles.area_template_name}>
                {previewObj.config.rebarPriceConfig.areaTemplateName}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className={cls(styles.row_item, styles.row_item_with_table)}>
        <div className={styles.label}>按类别浮动</div>
        <div className={styles.template_table_container}>
          {previewObj.config?.rebarPriceConfig?.areaDiscountRuleEnum === 2 && (
            <table className={styles.template_table}>
              <thead className={styles.template_table_header}>
                <tr>
                  <th rowSpan={2}>类别</th>
                  <th rowSpan={2}>单价计价公式类型</th>
                  <th rowSpan={2}>比例系数</th>
                  <th colSpan={regionList.length}>地区差值</th>
                </tr>
                <tr>
                  {regionList.map((item) => (
                    <th key={item.sysNo}>{item.name}</th>
                  ))}
                </tr>
              </thead>
              <tbody className={styles.template_table_body}>
                {previewObj.config.rebarPriceConfig.categoryDiscountList?.map((item) => (
                  <tr key={item.materialCategorySysNo}>
                    <td width="150">{item.categoryName}</td>
                    <td width="300">{item.formula}</td>
                    <td width="100">{item.formulaEnum === 1 ? '--' : `${item.paramList[0]}%`}</td>
                    {item.templateAreaDiscountList?.map((val) => (
                      <td key={val.templateAreaSysNo} className={styles.area_name_td}>
                        {val.discount}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          {previewObj.config?.rebarPriceConfig?.areaDiscountRuleEnum === 1 && (
            <Table
              pagination={false}
              columns={categoryDiscountListRenderInstruct}
              dataSource={previewObj.config.rebarPriceConfig.categoryDiscountList || []}
              bordered
            />
          )}
        </div>
      </div>
      {priceFloatList.map((v, i) => (
        <div className={cls(styles.row_item, styles.row_item_with_table)} key={i}>
          <div className={styles.label}>{v.label}</div>
          <Table
            pagination={false}
            columns={v.columns}
            dataSource={
              Array.isArray(previewObj.config.rebarPriceConfig[v.dataSourceAttr])
                ? previewObj.config.rebarPriceConfig[v.dataSourceAttr] || []
                : [previewObj.config.rebarPriceConfig[v.dataSourceAttr]]
            }
            bordered
          />
        </div>
      ))}
      {previewObj.config?.rebarPriceConfig?.discountByMethods && (
        <div className={cls(styles.row_item, styles.row_item_with_table)}>
          <div className={styles.label}>按交易方式浮动调价</div>
          <Table
            pagination={false}
            columns={tradeModePriceRenderInstructConcrete(previewObj, '单价')}
            dataSource={previewObj.config.rebarPriceConfig.discountByMethodList || []}
            bordered
          />
        </div>
      )}
    </>
  );
};

export const InformationPrice = ({ previewObj, children }) => {
  const attrName =
    previewObj.config.pricingModelEnum === pricingModelEnum.Information.value
      ? 'templatePriceConfig'
      : 'concreteCustomize';
  // 普通混凝土价格
  const normal = useMemo(() => {
    // 有可能返回多个normalAttributeConfigList
    const attributeSysNoValues = values(
      groupBy(
        previewObj.config.templatePriceConfig?.normalAttributeConfigList || [],
        'attributeSysNo',
      ),
    );

    var renderinstruction = [
      {
        dataIndex: 'attributeSysNo',
        title: '货品名称',
        width: '150px',
        align: 'center',
        render: function () {
          return '普通商品砼';
        },
      },
      {
        dataIndex: 'attributeSysNo',
        title: '强度等级',
        width: '300px',
        align: 'center',
        render: function (_, data) {
          return data.attributeValueList.join(', ');
        },
      },
      {
        dataIndex: 'net',
        title: '信息价来源',
        width: '100px',
        align: 'center',
        render: function () {
          return '信息价';
        },
      },
      {
        dataIndex: 'discountTypeEnum',
        title: '浮动类型',
        width: '100px',
        align: 'center',
        render: function (_, data) {
          return getEnumLabel({ enums: discountTypeEnum, value: data.discountTypeEnum });
        },
      },
      {
        dataIndex: 'discount',
        title: '浮动值',
        width: '100px',
        align: 'center',
        render: function (_, data) {
          if (data.discountType === discountTypeEnum.Ratio.value) {
            return data.discount + '%';
          } else {
            return data.discount;
          }
        },
      },
      {
        dataIndex: 'discountType',
        title: '单价计价公式',
        align: 'center',
        render: function (_, data) {
          if (data.discountTypeEnum === discountTypeEnum.Ratio.value) {
            var discount =
              data.discount > 0
                ? '1 + ' + +data.discount + '%'
                : '1 - ' + Math.abs(+data.discount) + '%';
            return '信息价 * ' + '(' + discount + ')';
          } else {
            var val =
              data.discount === 0
                ? '信息价'
                : data.discount > 0
                ? ' + ' + data.discount
                : ' - ' + Math.abs(data.discount);
            return '信息价' + val;
          }
        },
      },
    ];

    return {
      renderinstruction: renderinstruction,
      data: attributeSysNoValues[0] || [],
    };
  }, [previewObj]);
  const showBengsong = !!previewObj.config?.templatePriceConfig?.benchmarkEnumList?.includes(3);
  const showToushui = !!previewObj.config?.templatePriceConfig?.benchmarkEnumList?.includes(2);
  // 泵送普通混凝土价格
  const bengsong = useMemo(() => {
    // 有可能返回多个normalAttributeConfigList
    const attributeSysNoValues = values(
      groupBy(
        previewObj.config?.templatePriceConfig?.bengsongAttributeConfigList,
        'attributeSysNo',
      ),
    );

    var renderinstruction = [
      {
        dataIndex: 'attributeSysNo',
        title: '货品名称',
        width: '120px',
        align: 'center',
        render: function () {
          return '泵送商品砼';
        },
      },
      {
        dataIndex: 'attributeSysNo',
        title: '强度等级',
        width: '300px',
        align: 'center',
        render: function (_, data) {
          return data.attributeValueList.join(', ');
        },
      },
      {
        dataIndex: 'attributeSysNo1',
        title: '浇筑方式',
        width: '80px',
        align: 'center',
        render: function () {
          return '泵送';
        },
      },
      {
        dataIndex: 'net',
        title: '信息价来源',
        width: '100px',
        align: 'center',
        render: function () {
          return '信息价';
        },
      },
      {
        dataIndex: 'discountTypeEnum',
        title: '浮动类型',
        width: '100px',
        align: 'center',
        render: function (_, data) {
          return getEnumLabel({
            enums: discountTypeEnum,
            value: data.discountTypeEnum,
          });
        },
      },
      {
        dataIndex: 'discount',
        title: '浮动值',
        width: '100px',
        align: 'center',
        render: function (_, data) {
          if (data.discountType === discountTypeEnum.Ratio.value) {
            return data.discount + '%';
          } else {
            return data.discount;
          }
        },
      },
      {
        dataIndex: 'discountType',
        title: '单价计价公式',
        align: 'center',
        render: function (_, data) {
          if (data.discountTypeEnum === discountTypeEnum.Ratio.value) {
            var discount =
              data.discount > 0
                ? '1 + ' + +data.discount + '%'
                : '1 - ' + Math.abs(+data.discount) + '%';
            return '信息价 * ' + '(' + discount + ')';
          } else {
            var val =
              data.discount === 0
                ? '信息价'
                : data.discount > 0
                ? ' + ' + data.discount
                : ' - ' + Math.abs(data.discount);
            return '信息价' + val;
          }
        },
      },
    ];

    return {
      renderinstruction: renderinstruction,
      data: attributeSysNoValues[0] || [],
    };
  }, [previewObj]);
  // 透水普通混凝土价格
  const toushui = useMemo(() => {
    // 有可能返回多个normalAttributeConfigList
    const attributeSysNoValues = values(
      groupBy(previewObj.config?.templatePriceConfig?.toushuiAttributeConfigList, 'attributeSysNo'),
    );

    var renderinstruction = [
      {
        dataIndex: 'attributeSysNo',
        title: '货品名称',
        width: '120px',
        align: 'center',
        render: function () {
          return '透水商品砼';
        },
      },
      {
        dataIndex: 'attributeSysNo',
        title: '强度等级',
        width: '300px',
        align: 'center',
        render: function (_, data) {
          return data.attributeValueList.join(', ');
        },
      },
      {
        dataIndex: 'attributeSysNo1',
        title: '特殊类型',
        width: '80px',
        align: 'center',
        render: function () {
          return '透水';
        },
      },
      {
        dataIndex: 'net',
        title: '信息价来源',
        width: '100px',
        align: 'center',
        render: function () {
          return '信息价';
        },
      },
      {
        dataIndex: 'discountTypeEnum',
        title: '浮动类型',
        width: '100px',
        align: 'center',
        render: function (_, data) {
          return getEnumLabel({
            enums: discountTypeEnum,
            value: data.discountTypeEnum,
          });
        },
      },
      {
        dataIndex: 'discount',
        title: '浮动值',
        width: '100px',
        align: 'center',
        render: function (_, data) {
          if (data.discountType === discountTypeEnum.Ratio.value) {
            return data.discount + '%';
          } else {
            return data.discount;
          }
        },
      },
      {
        dataIndex: 'discountType',
        title: '单价计价公式',
        align: 'center',
        render: function (_, data) {
          if (data.discountTypeEnum === discountTypeEnum.Ratio.value) {
            var discount =
              data.discount > 0
                ? '1 + ' + +data.discount + '%'
                : '1 - ' + Math.abs(+data.discount) + '%';
            return '信息价 * ' + '(' + discount + ')';
          } else {
            var val =
              data.discount === 0
                ? '信息价'
                : data.discount > 0
                ? ' + ' + data.discount
                : ' - ' + Math.abs(data.discount);
            return '信息价' + val;
          }
        },
      },
    ];

    return {
      renderinstruction: renderinstruction,
      data: attributeSysNoValues[0] || [],
    };
  }, [previewObj]);
  // 厂站泵提供价格
  const mixStationProvidePumpAttributeConfigListRenderInstruct = [
    {
      dataIndex: 'categoryName',
      title: '分类',
      width: '150px',
      align: 'center',
    },
    {
      dataIndex: 'attributeValue',
      title: '是否提供厂站泵',
      width: '200px',
      align: 'center',
    },
    {
      dataIndex: 'discount',
      title: '浮动加（减）价',
      width: '200px',
      align: 'center',
    },
    {
      dataIndex: 'jiaozhufangshi',
      title: '单价计价公式',
      width: '200px',
      align: 'center',
      render: function (_, data) {
        var isBengsong =
          previewObj.config?.templatePriceConfig?.bengsongAttributeValueSysNoList?.find(
            (v) => data.attributeValueSysNo === v,
          );

        var showText = showBengsong && isBengsong ? '泵送混凝土价格' : '普通混凝土价格';
        var val =
          data.discount === 0
            ? ''
            : data.discount > 0
            ? ' + ' + data.discount
            : ' - ' + Math.abs(data.discount);
        return showText + val;
      },
    },
  ];
  const singleAttributeConfigListRenderInstruct = [
    {
      dataIndex: 'categoryName',
      title: '分类',
      width: '150px',
      align: 'center',
    },
    {
      dataIndex: 'attributeValue',
      title: '浇筑方式',
      width: '200px',
      align: 'center',
    },
    {
      dataIndex: 'discount',
      title: '浮动加（减）价',
      width: '200px',
      align: 'center',
    },
    {
      dataIndex: 'jiaozhufangshi',
      title: '单价计价公式',
      width: '200px',
      align: 'center',
      render: function (_, data) {
        var isBengsong =
          previewObj.config?.templatePriceConfig?.bengsongAttributeValueSysNoList?.find(
            (v) => data.attributeValueSysNo === v,
          );

        var showText = showBengsong && isBengsong ? '泵送混凝土价格' : '普通混凝土价格';
        var val =
          data.discount === 0
            ? ''
            : data.discount > 0
            ? ' + ' + data.discount
            : ' - ' + Math.abs(data.discount);
        return showText + val;
      },
    },
  ];
  const otherAttributeConfigListRenderInstruct = [
    {
      dataIndex: 'attribute',
      title: '属性名',
      width: '200px',
      align: 'center',
    },
    {
      dataIndex: 'attributeValue',
      title: '属性值',
      width: '200px',
      align: 'center',
    },
    {
      dataIndex: 'discount',
      title: '浮动加（减）价',
      width: '200px',
      align: 'center',
    },
    {
      dataIndex: 'jiaozhufangshi',
      title: '单价计价公式',
      width: '200px',
      align: 'center',
      render: function (_, data) {
        var isToushui =
          data.attributeValueSysNo ===
          previewObj.config?.templatePriceConfig?.toushuiAttributeValueSysNo;

        var showText = showToushui && isToushui ? '透水混凝土价格' : '普通混凝土价格';
        var val =
          data.discount === 0
            ? ''
            : data.discount > 0
            ? ' + ' + data.discount
            : ' - ' + Math.abs(data.discount);
        return showText + val;
      },
    },
  ];
  const fractureResistanceOtherAttributeConfigListRenderInstruct = [
    {
      dataIndex: 'attribute',
      title: '属性名',
      width: '200px',
      align: 'center',
    },
    {
      dataIndex: 'attributeValue',
      title: '属性值',
      width: '200px',
      align: 'center',
    },
    {
      dataIndex: 'discount',
      title: '浮动加（减）价',
      width: '200px',
      align: 'center',
    },
    {
      dataIndex: 'jiaozhufangshi',
      title: '单价计价公式',
      width: '200px',
      align: 'center',
      render: function (_, data) {
        var isToushui =
          data.attributeValueSysNo ===
          previewObj.config?.templatePriceConfig?.toushuiAttributeValueSysNo;

        var showText = showToushui && isToushui ? '透水混凝土价格' : '抗折混凝土协议价格';
        var val =
          data.discount === 0
            ? ''
            : data.discount > 0
            ? ' + ' + data.discount
            : ' - ' + Math.abs(data.discount);
        return showText + val;
      },
    },
  ];
  const doubleAttributeConfigListData =
    previewObj.config[attrName]?.fractureResistanceDiscountConfigList || [];
  const mixStationProvidePumpAttributeConfigListData =
    previewObj.config[attrName]?.mixStationProvidePumpAttributeConfigList || [];
  const singleAttributeConfigListData =
    previewObj.config[attrName]?.singleAttributeConfigList || [];

  const otherAttributeConfigListData = previewObj.config[attrName]?.otherAttributeConfigList || [];
  const fractureResistanceOtherAttributeConfigListData =
    previewObj.config[attrName]?.fractureResistanceOtherAttributeConfigList || [];
  return (
    <>
      <QuoteType config={previewObj.config[attrName]} />
      {previewObj.config[attrName]?.mixingStationConfigList?.length && (
        <div className={cls(styles.row_item, styles.row_item_with_table)}>
          <div className={styles.label}>适用搅拌站</div>
          <Table
            pagination={false}
            columns={mixingStationRenderInstruct}
            dataSource={previewObj.config[attrName]?.mixingStationConfigList || []}
            bordered
          />
        </div>
      )}
      {children || (
        <>
          <div className={cls(styles.row_item, styles.row_item_with_table)}>
            <div className={styles.label}>基准材料品类</div>
            <Table
              pagination={false}
              style={{ width: '300px' }}
              columns={[
                {
                  dataIndex: 'attributes',
                  title: '品类',
                  align: 'center',
                  render: function (_, data) {
                    if (data === 1) {
                      return '普通商品砼';
                    } else if (data === 2) {
                      return '透水商品砼';
                    } else if (data === 3) {
                      return '泵送商品砼';
                    }
                  },
                },
              ]}
              dataSource={previewObj.config?.templatePriceConfig?.benchmarkEnumList || []}
              bordered
            />
          </div>
          <div className={cls(styles.row_item, styles.row_item_with_table)}>
            <div className={styles.label}>普通混凝土价格</div>
            <Table
              pagination={false}
              columns={normal.renderinstruction}
              dataSource={normal.data}
              bordered
            />
          </div>
          {showBengsong && (
            <div className={cls(styles.row_item, styles.row_item_with_table)}>
              <div className={styles.label}>泵送混凝土价格</div>
              <Table
                pagination={false}
                columns={bengsong.renderinstruction}
                dataSource={bengsong.data}
                bordered
              />
            </div>
          )}
          {showToushui && (
            <div className={cls(styles.row_item, styles.row_item_with_table)}>
              <div className={styles.label}>透水混凝土价格</div>
              <Table
                pagination={false}
                columns={toushui.renderinstruction}
                dataSource={toushui.data}
                bordered
              />
            </div>
          )}
        </>
      )}
      <div className={cls(styles.row_item, styles.row_item_with_table)}>
        <div className={styles.label}>抗折价格</div>
        <Table
          pagination={false}
          columns={doubleAttributeConfigListRenderInstruct}
          dataSource={doubleAttributeConfigListData}
          bordered
        />
      </div>
      <div className={cls(styles.row_item, styles.row_item_with_table)}>
        <div className={styles.label}>厂站提供泵价格</div>
        <Table
          pagination={false}
          columns={mixStationProvidePumpAttributeConfigListRenderInstruct}
          dataSource={mixStationProvidePumpAttributeConfigListData}
          bordered
        />
      </div>
      <div className={cls(styles.row_item, styles.row_item_with_table)}>
        <div className={styles.label}>泵送价格</div>
        <Table
          pagination={false}
          columns={singleAttributeConfigListRenderInstruct}
          dataSource={singleAttributeConfigListData}
          bordered
        />
      </div>
      <div className={cls(styles.row_item, styles.row_item_with_table)}>
        <div className={styles.label}>普通混凝土特殊类型</div>
        <Table
          pagination={false}
          columns={otherAttributeConfigListRenderInstruct}
          dataSource={otherAttributeConfigListData}
          bordered
        />
      </div>
      <div className={cls(styles.row_item, styles.row_item_with_table)}>
        <div className={styles.label}>抗折混凝土特殊类型</div>
        <Table
          pagination={false}
          columns={fractureResistanceOtherAttributeConfigListRenderInstruct}
          dataSource={fractureResistanceOtherAttributeConfigListData}
          bordered
        />
      </div>
      {previewObj.config[attrName]?.discountByMethods && (
        <div className={cls(styles.row_item, styles.row_item_with_table)}>
          <div className={styles.label}>按交易方式浮动调价</div>
          <Table
            pagination={false}
            columns={tradeModePriceRenderInstructConcrete(previewObj, '单价')}
            dataSource={previewObj.config[attrName]?.discountByMethodList || []}
            bordered
          />
        </div>
      )}
    </>
  );
};

export const CustomPrice = ({ previewObj }) => {
  const normalCustomize = useMemo(() => {
    // 有可能返回多个normalAttributeConfigList
    const attributeSysNoValues = values(
      groupBy(previewObj.config.concreteCustomize.customizeBasisConfigList, 'attributeSysNo'),
    );

    var renderinstruction = [
      {
        dataIndex: 'attributeSysNo',
        title: '货品名称',
        width: '150px',
        align: 'center',
        render: function () {
          return '普通商品砼';
        },
      },
      {
        dataIndex: 'attributeValue',
        title: '强度等级',
        width: '300px',
        align: 'center',
      },
      {
        dataIndex: 'price',
        title: '价格',
        width: '100px',
        align: 'center',
      },
    ];

    return {
      renderinstruction: renderinstruction,
      data: attributeSysNoValues[0] || [],
    };
  }, [previewObj]);
  return (
    <InformationPrice previewObj={previewObj}>
      <div className={cls(styles.row_item, styles.row_item_with_table)}>
        <div className={styles.label}>普通混凝土价格</div>
        <Table
          pagination={false}
          columns={normalCustomize.renderinstruction}
          dataSource={normalCustomize.data}
          bordered
        />
      </div>
    </InformationPrice>
  );
};

export const MaterialPrice = ({ previewObj }) => {
  const isShangHaiYouSe =
    previewObj.config.renovationConfig?.netPriceSourceEnum === NetPriceSourceEnum.SHYSJSW;
  const baseNetPrice2RenderInstruct = [
    {
      title: '基准材料规格型号',
      align: 'center',
      children: [
        {
          dataIndex: 'indexName',
          title: '品种',
          width: '465px',
          align: 'center',
        },
      ],
    },
    {
      title: '含税基准价C',
      align: 'center',
      children: [
        {
          dataIndex: 'price',
          title: '含税基准价(元/吨)',
          width: '465px',
          align: 'center',
        },
      ],
    },
  ];
  const baseNetPriceAttr = isShangHaiYouSe ? 'baseNetPrice2' : 'baseNetPrice1';
  const rateConfigRenderInstruct = [
    {
      dataIndex: 'rate',
      title: '条件',
      width: '130px',
      align: 'center',
      render: function (_, data, index) {
        if (index === 0) {
          return '价格波动± ' + data.rate + '%';
        } else if (index === 1) {
          return '涨幅超过' + data.rate + '%';
        } else if (index === 2) {
          return '跌幅超过' + data.rate + '%';
        } else if (index === 3) {
          return '涨幅超过' + data.rate + '%';
        } else if (index === 4) {
          return '跌幅超过' + data.rate + '%';
        }
      },
    },
    {
      dataIndex: 'formula',
      title: '公式选择',
      width: '400px',
      align: 'center',
      render: function (_, data, index) {
        if (index === 0) {
          return '不调价';
        } else {
          return data.formula;
        }
      },
    },
    {
      dataIndex: 'formulaString',
      title: '单价计价公式',
      width: '400px',
      align: 'center',
      render: function (_, data, index) {
        if (index === 0) {
          return '不调价';
        } else {
          return data.formulaString;
        }
      },
    },
  ];
  const range1ConfigRenderInstruct = [
    {
      dataIndex: 'formula',
      title: '公式选择',
      width: '465px',
      align: 'center',
    },
    {
      dataIndex: 'formulaString',
      title: '单价计价公式',
      width: '465px',
      align: 'center',
    },
  ];
  const range2ConfigRenderInstruct = [
    {
      dataIndex: 'areaName',
      title: '条件',
      align: 'center',
      width: '465px',
      render: function (_, data, index) {
        var { upperLimit } = data;
        var { lowerLimit } = data;
        var name = previewObj.config.renovationConfig.baseNetPrice2.indexName + '（含税）';
        var configList = previewObj.config.renovationConfig.rangeConfig.configList || [];
        var { length } = configList;
        if (index === 0) {
          return upperLimit + '元≥' + name + '≥' + lowerLimit + '元';
        } else if (index === 1) {
          return name + '≥' + lowerLimit + '元';
        } else if (index === length - 1) {
          return name + '<' + upperLimit + '元';
        } else {
          return upperLimit + '元>' + name + '≥' + lowerLimit + '元';
        }
      },
    },
    {
      dataIndex: 'xn',
      title: 'Xn取值',
      width: '465px',
      align: 'center',
      render: function (_, data, index) {
        if (index === 0) {
          return '不调价';
        } else {
          return data.xn == null ? '用户自行填写价格' : 'Xn=' + data.xn + '%';
        }
      },
    },
  ];
  const wireCableRangeConfigRenderInstruct = [
    {
      dataIndex: 'upperLimit',
      title: '条件',
      width: '130px',
      align: 'center',
      render: function (_, data, index) {
        if (index === 0) {
          return '|B-C|≤' + data.upperLimit + '时';
        } else {
          return (
            '|B-C|>' +
            previewObj.config.renovationConfig?.wireCableRangeConfig?.configList?.[0]?.upperLimit +
            '时'
          );
        }
      },
    },
    {
      dataIndex: 'formulaString',
      title: '公式选择',
      width: '400px',
      align: 'center',
      render: function (_, data, index) {
        if (index === 0) {
          return '不调价';
        } else {
          return previewObj.config.renovationConfig?.wireCableRangeConfig?.formulaString;
        }
      },
    },
    {
      dataIndex: 'y',
      title: '单价计价公式',
      width: '400px',
      align: 'center',
      render: function (_, data, index) {
        if (index === 0) {
          return '不调价';
        } else {
          return previewObj.config.renovationConfig?.wireCableRangeConfig?.formulaString?.replace(
            'y',
            data.y,
          );
        }
      },
    },
  ];
  const getPriceRuleList = [
    {
      title: () => '以哪个环节的日期为准取定基价',
      render() {
        return [...accountPeriodTypes]
          .filter((v) => previewObj.config.accountPeriodEnumList.includes(v.value))
          .sort((a, b) => a.seq - b.seq)
          .map((v, i) => (
            <div className={styles.value_block_list_item} key={i}>
              • {v.label}方式，取
              {previewObj.config?.renovationConfig?.takePriceRule && (
                <span className={styles.value_block_list_item_light_txt}>
                  {previewObj.config.renovationConfig.takePriceRule[v.netPriceAttr]}
                </span>
              )}
              网价
            </div>
          ));
      },
    },
    {
      title: () => (
        <>
          <span>取当天哪一条网价</span>
          <Popover
            color="#515151"
            content={
              <div className={styles.mode_tooltip_content}>
                <p>均以当天提交单据时已发布的网价进行计算</p>
              </div>
            }
            trigger="hover"
          >
            <i className={cls('iconfont icon-question1', styles.pay_question_icon)} />
          </Popover>
        </>
      ),
      render: () => `• ${previewObj.config.renovationConfig?.takePriceRule?.priceSelect}`,
      hide: isShangHaiYouSe,
    },
    {
      title: () => '当天取价时暂未发布网价规则',
      render: () => '• 取前1个工作日的网价',
    },
    {
      title: () => '节假日，周末取价规则',
      render: () => '• 周末取周五的网价，节假日取放假前一天网价，如遇到周末，顺延至周五',
    },
    {
      title: () => '不满足上述情况，采购方手动输入单价',
      render: () => '',
    },
  ];
  return (
    <>
      <QuoteType config={previewObj.config.renovationConfig} />
      <div className={styles.row_item}>
        <div className={styles.label}>网价来源:</div>
        <div className={styles.value}>
          <div className={styles.value_item}>
            {previewObj.config.renovationConfig?.netPriceSource}
          </div>
        </div>
      </div>
      {previewObj.config.pricingModelEnum === pricingModelEnum.Material.value &&
        isShangHaiYouSe && (
          <div className={styles.row_item}>
            <div className={styles.label} style={{ width: '260px' }}>
              是否电线电缆计价模板(2026年新集采):
            </div>
            <div className={styles.value}>
              <div className={styles.value_item}>
                {previewObj.config.renovationConfig?.isWireCableTemplate ? '是' : '否'}
              </div>
            </div>
          </div>
        )}
      <div className={cls(styles.row_item, styles.row_item_with_table)}>
        <div className={styles.label}>
          基准规格及含税基准价C:
          {!isShangHaiYouSe && (
            <span className={styles.label_title_sub}>
              地区不选择，则取下单时收货地址所在区域的网价
            </span>
          )}
        </div>
        {previewObj.config.renovationConfig && (
          <Table
            pagination={false}
            columns={baseNetPrice2RenderInstruct}
            dataSource={
              previewObj.config.renovationConfig[baseNetPriceAttr]
                ? [previewObj.config.renovationConfig[baseNetPriceAttr]]
                : []
            }
            bordered
          />
        )}
      </div>
      <div className={styles.row_item}>
        <div className={styles.label}>计价规则:</div>
        <div className={styles.value}>
          <div className={styles.value_item}>
            <div>
              {previewObj.config.renovationConfig?.priceRule}
              {previewObj.config.renovationConfig?.isWireCableTemplate ? (
                <div className={styles.price_rule_list_wrap}>
                  {previewObj.config.renovationConfig.quoteModeEnum ===
                  templatePriceConfigQuoteMode.PreTax.value ? (
                    <>
                      <div>A指的是商品含税协议价/（1+税率），单位为元/m</div>
                      <div>D指的是电缆铜含量，单位为t/m，y为单位换算调节系数</div>
                      <div>B指的实时市场价/（1+税率），单位为元/t</div>
                      <div>C指的是含税基准价/（1+税率），单位为元/t</div>
                    </>
                  ) : (
                    <>
                      <div>A指的是商品含税协议价，单位为元/m</div>
                      <div>D指的是电缆铜含量，单位为t/m，y为单位换算调节系数</div>
                      <div>B指的实时市场价，单位为元/t</div>
                      <div>C指的是含税基准价，单位为元/t</div>
                    </>
                  )}
                </div>
              ) : (
                <div className={styles.price_rule_list_wrap}>
                  {previewObj.config.renovationConfig.quoteModeEnum ===
                  templatePriceConfigQuoteMode.PreTax.value ? (
                    <>
                      <div>A指的是供应商不含税报价</div>
                      <div>B指的是基准规格的实时市场价/（1+税率）</div>
                      <div>C指的是基准规格设定的含税基准价/（1+税率）</div>
                    </>
                  ) : (
                    <>
                      <div>A指的是供应商含税报价</div>
                      <div>B指的是基准规格的实时市场价</div>
                      <div>C指的是基准规格设定的含税基准价</div>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {previewObj.config.renovationConfig.isWireCableTemplate ? (
        <Table
          pagination={false}
          columns={wireCableRangeConfigRenderInstruct}
          dataSource={previewObj.config.renovationConfig?.wireCableRangeConfig?.configList || []}
          bordered
        />
      ) : previewObj.config.renovationConfig.priceRuleEnum === priceRuleList.Ratio.value ? (
        <Table
          pagination={false}
          columns={rateConfigRenderInstruct}
          dataSource={previewObj.config.renovationConfig?.rateConfig?.configList || []}
          bordered
        />
      ) : (
        <>
          <Table
            pagination={false}
            columns={range1ConfigRenderInstruct}
            dataSource={
              previewObj.config.renovationConfig?.rangeConfig
                ? [previewObj.config.renovationConfig?.rangeConfig]
                : []
            }
            bordered
          />
          <div style={{ marginTop: '15px' }}>
            <Table
              pagination={false}
              columns={range2ConfigRenderInstruct}
              dataSource={previewObj.config.renovationConfig.rangeConfig.configList || []}
              bordered
            />
          </div>
        </>
      )}

      <div className={cls(styles.row_item, styles.mt20)}>
        <div className={styles.label}>取价规则:</div>
        <div className={styles.value}>
          {getPriceRuleList
            .filter((v) => !v.hide)
            .map((v, i) => (
              <div className={styles.value_block_wrap} key={i}>
                <div className={styles.value_block_title}>
                  ({i + 1}) {v.title()}
                </div>
                <div>{v.render()}</div>
              </div>
            ))}
        </div>
      </div>

      {previewObj.config?.renovationConfig?.discountByMethods && (
        <div className={cls(styles.row_item, styles.row_item_with_table)}>
          <div className={styles.label}>按交易方式浮动调价</div>
          <Table
            pagination={false}
            columns={tradeModePriceRenderInstructConcrete(previewObj, '单价')}
            dataSource={previewObj.config.renovationConfig.discountByMethodList || []}
            bordered
          />
        </div>
      )}
    </>
  );
};

export const AluminumPrice = ({ previewObj }) => {
  const categoryDiscountListRenderInstruct = [
    {
      dataIndex: 'indexName',
      title: '品种',
      width: '200px',
      align: 'center',
    },
    {
      dataIndex: 'formula',
      title: '单价计价公式类型',
      width: '200px',
      align: 'center',
    },
    {
      dataIndex: 'formulaString',
      title: '单价计价公式',
      width: '272px',
      align: 'center',
    },
  ];
  const getPriceRuleList = [
    {
      title: () => '(1) 以哪个环节的日期为准取定基价',
      render() {
        return [...accountPeriodTypes]
          .filter((v) => previewObj.config.accountPeriodEnumList.includes(v.value))
          .sort((a, b) => a.seq - b.seq)
          .map((v, i) => (
            <div className={styles.value_block_list_item} key={i}>
              • {v.label}方式，取
              {previewObj.config?.aluminumConfig?.takePriceRule && (
                <span className={styles.value_block_list_item_light_txt}>
                  {previewObj.config.aluminumConfig.takePriceRule[v.netPriceAttr]}
                </span>
              )}
              网价
            </div>
          ));
      },
    },
    {
      title: () => '(2) 当天取价时暂未发布网价规则',
      render: () => '• 取前1个工作日的网价',
    },
    {
      title: () => '(3) 节假日，周末取价规则',
      render: () =>
        '• 周末取周五的网价，节假日取放假前一天同城市，同品牌，同规格型号网价，如遇到周末，顺延至周五',
    },
    {
      title: () => '(4) 网价单位和商品单位一致',
      render: () => '',
    },
    {
      title: () => '(5) 不满足上述情况，使用店铺销售价',
      render: () => '',
    },
  ];
  previewObj.config?.aluminumConfig &&
    (previewObj.config.aluminumConfig.quoteModeEnum =
      templatePriceConfigQuoteMode.IncluedTax.value);
  return (
    <>
      <QuoteType config={previewObj.config?.aluminumConfig} />
      <div className={styles.row_item}>
        <div className={styles.label}>网价来源:</div>
        <div className={styles.value}>
          <div className={styles.value_item}>
            {previewObj.config?.aluminumConfig?.netPriceSource}
          </div>
        </div>
      </div>
      <div className={styles.row_item}>
        <div className={styles.label}>价格类型:</div>
        <div className={styles.value}>
          <div className={styles.value_item}>市场价</div>
        </div>
      </div>
      <div className={styles.row_item}>
        <div className={styles.label}>取价规则:</div>
        <div className={styles.value}>
          {getPriceRuleList.map((v, i) => (
            <div className={styles.value_block_wrap} key={i}>
              <div className={styles.value_block_title}>{v.title()}</div>
              <div>{v.render()}</div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.row_item}>
        <div className={styles.label}>浮动规则:</div>
        <div className={styles.value}>
          <div className={styles.value_item}>
            {previewObj.config?.aluminumConfig?.areaDiscountRule}
          </div>
        </div>
      </div>
      <div className={cls(styles.row_item, styles.row_item_with_table)}>
        <div className={styles.label}>基准规格</div>
        <div className={styles.template_table_container}>
          <Table
            pagination={false}
            columns={categoryDiscountListRenderInstruct}
            dataSource={
              Array.isArray(previewObj.config.aluminumConfig.baseNetPrice)
                ? previewObj.config.aluminumConfig.baseNetPrice || []
                : [previewObj.config.aluminumConfig.baseNetPrice]
            }
            bordered
          />
        </div>
      </div>
      {aluminumPriceFloatList.map((v, i) => (
        <div className={cls(styles.row_item, styles.row_item_with_table)} key={i}>
          <div className={styles.label}>{v.label}</div>
          <Table
            pagination={false}
            columns={v.columns}
            dataSource={
              Array.isArray(previewObj.config.aluminumConfig[v.dataSourceAttr])
                ? previewObj.config.aluminumConfig[v.dataSourceAttr] || []
                : [previewObj.config.aluminumConfig[v.dataSourceAttr]]
            }
            bordered
          />
        </div>
      ))}
      {previewObj.config?.aluminumConfig?.discountByMethods && (
        <div className={cls(styles.row_item, styles.row_item_with_table)}>
          <div className={styles.label}>按交易方式浮动调价</div>
          <Table
            pagination={false}
            columns={tradeModePriceRenderInstructConcrete(previewObj, '单价')}
            dataSource={previewObj.config.aluminumConfig.discountByMethodList || []}
            bordered
          />
        </div>
      )}
    </>
  );
};
